import React, { cloneElement } from 'react';
import classNames from 'classnames';
import { makeStyles } from '../styles';
const useStyles = makeStyles(() => ({
    tabsRoot: {
        position: 'relative',
        display: 'flex',
    },
}));
function Tabs({ className, children: childrenProp, value, onChange, }) {
    const classes = useStyles();
    const handleTabClick = (event) => () => {
        onChange(event);
    };
    const children = React.Children.map(childrenProp, child => {
        if (!child || typeof child !== 'object' || !('props' in child))
            return null;
        const additionalProps = {
            selected: false,
            onClick: handleTabClick({ value: child.props.value }),
        };
        if (child.props.value === value) {
            additionalProps.selected = true;
        }
        return cloneElement(child, { ...additionalProps });
    });
    return (React.createElement("div", { className: classNames(className, classes.tabsRoot) }, children));
}
export default Tabs;
//# sourceMappingURL=Tabs.js.map